import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../core/service/http.service";
import { UserIdleService } from 'angular-user-idle';


@Injectable({
  providedIn: "root",
})
export class DoctorService {
  constructor(private httpService: HttpService,
    private userIdle: UserIdleService
    ) {
      this.restart()
    }

  GetDashboardCount(doctorDetails: any): Observable<any> {
    return this.httpService.post(
      "doctor/GetDoctorDashboardStat",
      doctorDetails
    );
  }
  GetDoctorList(doctorDetails: any): Observable<any> {
    return this.httpService.post("doctor/GetDoctorList", doctorDetails);
  }
  GetDoctorDetailsById(doctorDetails: any): Observable<any> {
    return this.httpService.post("doctor/GetDoctorProfile", doctorDetails);
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
